<!-- <h2><p class = "edit_for_power_user_role" >Admin : User Management : Edit Power User Role</p></h2>

  
<form [formGroup]="assignRoleToPowerUserForm">
  <mat-form-field class="power_user_field" appearance="outline">
    <mat-label>Power User # </mat-label>
    <input matInput formControlName="powerUserId">
  </mat-form-field>

  <mat-form-field appearance="outline" class="status_field">
    <mat-label>User Role Status </mat-label>
    <input matInput formControlName="status">
  </mat-form-field>

  <button mat-raised-button class="update_status_button" color="primary" (click)="OnClickChangeStatus()">Change Status</button><br>

  <mat-form-field class="name_width" appearance="outline">
    <mat-label>Name </mat-label>
    <input matInput formControlName="name">
  </mat-form-field><br>

  <mat-form-field appearance="outline" class="select_role">    

    <mat-select [(value)]="currentRole" (selectionChange)="onSelectRole($event.value)" formControlName="selectRole">
      <mat-option *ngFor="let role of this.userService.powerUserStatusTypes" value="{{role.Code}}">{{role.Name}}</mat-option>
    </mat-select>
  </mat-form-field> <br>



  <mat-form-field class="other_width" appearance="outline">
    <mat-label>Start Date</mat-label>
    <input matInput [matDatepicker]="startDatePicker" required formControlName="startDate">
    <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
    <mat-datepicker #startDatePicker></mat-datepicker>
  </mat-form-field> <br>

  <mat-form-field class="other_width" appearance="outline">
    <mat-label>End Date</mat-label>
    <input matInput [matDatepicker]="endDatePicker" formControlName="endDate">
    <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
    <mat-datepicker #endDatePicker></mat-datepicker>
  </mat-form-field>



  <div class="subject-area">
    <br>

    <mat-label><span class="subject-header">Subject</span></mat-label>


    <button mat-raised-button color="primary" class="add_subject_field_button" (click)="addvalue()">Add Subject</button> <br> <br>

    <mat-form-field appearance="outline" class="select_subject">
      <mat-label>Select Primary Subject <span style="color: red">*</span></mat-label>
      <mat-select (selectionChange)="onSelectPrimarySubject($event.value)">
        <mat-option *ngFor="let subject of subjectType" value="{{subject.Code}}">{{subject.Name}}</mat-option>
      </mat-select>
    </mat-form-field>

    <div *ngFor="let value of values; let i = index">

      <mat-form-field appearance="outline" class="subject_input">
        <mat-label>Select Additional Subject </mat-label>
        <mat-select (selectionChange)="onSelectAdditionalSubject($event.value)">
          <mat-option *ngFor="let subject of subjectType" value="{{subject.Code}}">{{subject.Name}}</mat-option>
        </mat-select>
      </mat-form-field>


      <button mat-raised-button (click)="removevalue(i)" class="remove_button">Remove</button>

    </div>



  </div>
  <br>


  <mat-form-field class="example-full-width" appearance="outline">
    <mat-label>Comments/Notes</mat-label>
    <textarea matInput formControlName="comments"></textarea>
  </mat-form-field> <br>


  <button mat-raised-button class="mat-button" color="primary" (click)="OnClickSaveButton()">Save</button>

  <button mat-raised-button class="mat-button" color="primary">Clear</button>

  <button mat-raised-button class="mat-button" (click)="OnClickCancelButton()">Cancel</button>
  <br> <br>

</form> -->


<div class="row">
  <div class="col-12">
   
      <div class="row" class="row border Page-Header">
        <div class="col-12">
          <h6 class="HeadContent">Edit Power User Role</h6>
        </div>
      </div>
      <div class="row pt-1" >
        <div class="col-12">
<div class="row">


      <div class="col-12" [ngClass]="{'my-disable':PowerUserRoleInd=='N'}">

        <form [formGroup]="assignRoleToPowerUserForm">
          <div class="row pt-1">
            <div class="col-2 text-right  pt-1 pl-1 pr-0">
              <div class="d-flex flex-row-reverse">
                <!-- <div class="p-0 label-red">*</div>          -->
                <div class="p-0">Power User #</div>                 
                </div>
             
            </div>
            <div class="col-4 pt-1 px-1">
              <input type="text"  formControlName="powerUserId" [attr.disabled]="true" readonly="readonly" class="form-control form-control-sm input-txt"/>
            </div>
            <div class="col-6 pt-1 px-1">
              <div class="d-flex">
                <div class="px-2">
                  <div class="p-0">Role Status</div>
                  
                  
                </div>
                <div class="px-1">
                  <div class="p-0">
                    <input type="text" formControlName="status" [attr.disabled]="true" readonly="readonly" class="form-control form-control-sm input-txt11"/>
                  </div>
                </div>
                <div class="px-1">
                  <button type="button"  class="btn btn-sm bg-light border" [disabled]="PowerUserRoleInd=='N'" (click)="OnClickCStatusButton()">Change Status</button>
                  
                  
                </div>
                
              </div>
            </div>
          </div>
          <div class="row pt-1">
            <div class="col-2 text-right  pt-1 pl-1 pr-0">
              <div class="d-flex flex-row-reverse">
                <!-- <div class="p-0 label-red">*</div>          -->
                <div class="p-0">Name</div>                 
                </div>
             
            </div>
            <div class="col-10 pt-1 px-1">
              <input type="text"   formControlName="name" [attr.disabled]="true" readonly="readonly" class="form-control form-control-sm input-txt"/>
            </div>
          </div>
          <div class="row pt-1">
            <div class="col-2 text-right  pt-1 pl-1 pr-0">
              <div class="d-flex flex-row-reverse">
                <!-- <div class="p-0 label-red">*</div>          -->
                <div class="p-0">Select Role</div>                 
                </div>
             
            </div>
            <div class="col-10 pt-1 px-1">
              <select  class="form-control form-control-sm input-txt" [attr.disabled]="true" (change)="onSelectRole($event)" formControlName="selectRole">
                   
                <option class="border-bottom" [disabled]="true" *ngFor="let role of this.selectRole" value="{{role.Code}}">{{role.Name}}</option>
              </select>
            </div>
          </div>
          <div class="row pt-1">
            <div class="col-2 text-right  pt-1 pl-1 pr-0">
              <div class="d-flex flex-row-reverse">
                <div class="p-0 label-red">*</div>         
                <div class="p-0">Start date</div>                 
                </div>
             
            </div>
            <div class="col-10 pt-1 px-1">
              <input 
              type="text" 
              [ngClass]="{'my-disable1':PowerUserRoleInd=='N'}" 
              formControlName="startDate" 
              [owlDateTime]="dt1" 
              [owlDateTimeTrigger]="dt1"
              class="form-control form-control-sm input-txt" 
              (dateTimeChange)="onStartDateChanged($event)"
        >

            <owl-date-time  [pickerType]="'calendar'" #dt1></owl-date-time>
            </div>
            <div class="col-2"></div>
           <div class="col-10 pt-1 px-1"><label  class="Valid1"  *ngIf="error1.isError">{{error1.errorMessage}}</label>
          </div>
          </div>
          <div class="row pt-1">
            <div class="col-2 text-right  pt-1 pl-1 pr-0">
              <div class="d-flex flex-row-reverse">
                <!-- <div class="p-0 label-red">*</div>          -->
                <div class="p-0">End date</div>                 
                </div>
             
            </div>
            <div class="col-10 pt-1 px-1">
              <input type="text"  [ngClass]="{'my-disable1':PowerUserRoleInd=='N'}" formControlName="endDate" [owlDateTime]="dt2" [owlDateTimeTrigger]="dt2"
              class="form-control form-control-sm input-txt" (dateTimeChange)="compareEndDates()" >
            <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time>
            </div>
            <div class="col-2"></div>
              <div class="col-10 pt-1 px-1"><label  class="Valid1" *ngIf="error.isError">{{ error.errorMessage }}</label></div>
          </div>
          <div class="row pt-1">
            <div class="col-2 text-right  pt-1 pl-1 pr-0">
              <div class="d-flex flex-row-reverse">
                <!-- <div class="p-0 label-red">*</div>          -->
                <div class="p-0">Subject</div>                 
                </div>
             
            </div>
            <div class="col-10 pt-1 px-1">
              <div class="d-flex">
                <div class="px-0">
                  <button type="button"  class="btn btn-sm bl-btn" [disabled]="PowerUserRoleInd=='N'" (click)="addvalue()">Add Subject</button>
                </div>
              </div>
            </div>
          </div>
          <div class="row pt-1">
            <div class="col-2 text-right  pt-1 pl-1 pr-0">
              <div class="d-flex flex-row-reverse">
                <div class="p-0 label-red">*</div>         
                <div class="p-0">Select Primary Subject</div>                 
                </div>
             
            </div>
            <div class="col-10 pt-1 px-1">
              <select  class="form-control form-control-sm input-txt" formControlName="primarySubject" [ngClass]="{'my-disable1':PowerUserRoleInd=='N'}" (click)="getvalue($event)" (ngModelChange)="Editformvalidation()" (change)="onSelectPrimarySubject($event)">
                   
                <option class="border-bottom" *ngFor = "let subject of subjectType"  [value]="subject.Code" >{{subject.Description}}</option>
              </select>
            </div>
          </div>
          
        </form>
          <div class="row pt-1" *ngFor="let value of values;let i = index" >
            <div class="col-2 text-right  pt-1 pl-1 pr-0">
              <div class="d-flex flex-row-reverse">
                <!-- <div class="p-0 label-red">*</div>          -->
                <div class="p-0">Select Additional Subject</div>                 
                </div>
             
            </div>
            <div class="col-10 pt-1 px-1">
              <div class="d-flex">
                <div class="px-0">
     
                  <select   class="form-control form-control-sm input-txt" [ngClass]="{'my-disable1':PowerUserRoleInd=='N'}" [(ngModel)]="value.Code" (click)="getvalue($event)" (ngModelChange)="Editformvalidation()" (change)="onSelectAdditionalSubject($event,i)" >
                    <!-- <option selected value="value.Code" hidden></option> -->
                    <option class="border-bottom" *ngFor = "let subject of subjectType" [value]="subject.Code">{{subject.Description}}</option>
                  </select>
                
                </div>
                <div class="px-1">
                  <button type="button"  class="btn btn-sm bg-light border" (click)="removevalue(i,value)">Remove</button>
                </div>
               
               
               
                
              </div>
            </div>
          </div>
          <form [formGroup]="assignRoleToPowerUserForm">
          <div class="row pt-1">
            <div class="col-2 text-right  pt-1 pl-1 pr-0">
              <div class="d-flex flex-row-reverse">
                <!-- <div class="p-0 label-red">*</div>          -->
                <div class="p-0">Comments/Notes</div>                 
                </div>
             
            </div>
            <div class="col-8 pt-1 px-1">
              <textarea  maxlength="4000" formControlName="comments" [ngClass]="{'my-disable1':PowerUserRoleInd=='N'}" (ngModelChange)="Editformvalidation()" class="form-control input-txt1"
              ></textarea>
            </div>
          </div>
       
         
    
         
         
         <div class="row pt-3 pb-1">
          <div class="col-2">
           
           
          </div>
          <div class="col-8 pt-1 px-1" *ngIf="PowerUserRoleInd=='Y'">
            <div class="d-flex">
              <div class="px-1">
              
              <button type="submit"  class="btn btn-sm bl-btn"  [disabled] = "assignRoleToPowerUserForm.invalid||error.isError||error1.isError" (click)="OnClickSaveButton()">Save</button>
              </div>
              <div class="px-1">
                <button type="button"   class="btn btn-sm bg-light border"  (click)="Cancelbutton()">Cancel</button>
              </div>
             
              
            </div>
          </div>
        </div>
   
      </form>
      
        
            </div>
            <div class="row pb-1">
              <div class="col-2">
              </div>
            <div class="col-8  px-1" *ngIf="PowerUserRoleInd=='N'">
              <div class="d-flex">
                <div class="px-1">
                  <button type="button"   class="btn btn-sm bg-light border"  (click)="Closebutton()">Close</button>
                </div>
              </div>
            </div>
            </div>
            
         
   
            
           
         
 
        <!-- <div class="col-4">

          <div class="row pt-1">
            <div class="col-4 text-right  pt-1 pl-1 pr-0">
              <div class="d-flex flex-row-reverse">
               
                <div class="p-0">User Status</div>                 
                </div>
             
            </div>
            <div class="col-8 pt-1 px-1">
              <input type="text" formControlName="status" [attr.disabled]="true" readonly="readonly" class="form-control form-control-sm input-txt11"/>
            </div>
          </div>
          <div class="row pt-2">
            <div class="col-4">
              
             
            </div>
            <div class="col-8 pt-1 px-1">
              <div class="d-flex">
                <div class="px-1">
                 
                <button type="submit"  class="btn btn-sm bg-light border"  (click)="OnClickCStatusButton()">Change Status</button>
                </div>
               
               
                
              </div>
            </div>
          </div>
         
        </div> -->
      </div>
     
      </div>
        </div>
    
  </div>
</div>

<div class="modal fade  show Model_popup1" *ngIf="ChangePowerUserRoleStatus">
  <div class="modal-dialog modal-dialog-centered modal-dialog-StudyMaterial">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">Change Power User Role Status</h6>
        <button type="button" class="close" (click)="OnClickCStatusButton()"
          style="padding-right: 20px;font-size: 30px;outline: 0;">
          <span aria-hidden="true">&times;</span></button>
      </div>
     
      <div class="modal-body px-3 py-0">
        
      <app-change-power-user-role-status (Closepopup)="Closepopup($event)"></app-change-power-user-role-status>
      </div>
    </div>
  </div>
</div>
<div class="modal fade  show modal-dialog-centered"style="padding-right: 4px;display: block;background-color: #00000075;" *ngIf="deletealertpopup">
  <div class="modal-dialog modal-dialog-alert modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">Alert</h6>
        <button type="button" class="close" 
          style="padding-right: 20px;font-size: 30px;outline: 0;" (click)="Removealertpopup()">
          <span aria-hidden="true">&times;</span></button>
      </div>
     
      <div class="modal-body px-3 py-0">
        <div class="row py-2 mx-2 pt-3">
          <div class="col-12">
            <label>Do you want to remove the subject?</label>
          </div>
        </div>
        <div class="row p-1">
          <div class="col-12">
            <div class="d-flex justify-content-center">
              <div class="px-1">
                <button type="button"  class="btn btn-sm bl-btn" (click)="Remove()">Yes</button>
              </div>
              <div class="px-1">
                <button type="button"  class="btn btn-sm bg-light border" (click)="Removealertpopup()">No</button>
              </div>
              
            </div>
          </div>
        </div>
      
      </div>
    </div>
  </div>
</div>
<div class="modal fade  show modal-dialog-centered"style="padding-right: 4px;display: block;background-color: #00000075;" *ngIf="subjectalertflag">
  <div class="modal-dialog modal-dialog-alert2 modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">Alert</h6>
        <!-- <button type="button" class="close" 
          style="padding-right: 20px;font-size: 30px;outline: 0;">
          <span aria-hidden="true">&times;</span></button> -->
      </div>
     
      <div class="modal-body px-3 py-0">
        <div class="row py-2 mx-2 pt-3">
          <div class="col-12">
            <label>Subject Already Selected</label>
          </div>
        </div>
        <div class="row p-1">
          <div class="col-12">
            <div class="d-flex justify-content-center">
              <div class="px-1">
                <button type="button"  class="btn btn-sm bg-light border" (click)="clearform()" >OK</button>
              </div>
              
            </div>
          </div>
        </div>
      
      </div>
    </div>
  </div>
</div>

<div class="modal fade  show modal-dialog-centered"style="padding-right: 4px;display: block;background-color: #00000075;" *ngIf="cancelalertflag">
  <div class="modal-dialog modal-dialog-alert1 modal-dialog-centered" >
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">Alert</h6>
        <button type="button" class="close" 
          style="padding-right: 20px;font-size: 30px;outline: 0;" (click)="AlertCancelpopup()">
          <span aria-hidden="true">&times;</span></button>
      </div>
     
      <div class="modal-body px-3 py-0">
        <div class="row py-2 mx-2 pt-3">
          <div class="col-12">
            <label>Do you want to Discard or Continue Editing ?</label>
          </div>
        </div>
        <div class="row p-1">
          <div class="col-12">
            <div class="d-flex justify-content-center">
              <div class="px-1">
                <button type="button"  class="btn btn-sm bg-light border" (click)="DiscardChanges()">Discard Changes</button>
              </div>
              <div class="px-1">
                <button type="button"  class="btn btn-sm bl-btn" (click)="AlertCancelpopup()">Continue Editing</button>
              </div>
              
            </div>
          </div>
        </div>
      
      </div>
    </div>
  </div>
</div>
